import includes from 'lodash/includes';

import { PeopleSecondaryMenuItems } from '../../CompactPeopleSecondaryMenu.types';

function getPeopleActiveMenu(
  pathname: string
): PeopleSecondaryMenuItems | null {
  if (includes(pathname, '/companies')) {
    return PeopleSecondaryMenuItems.COMPANIES;
  }

  if (includes(pathname, '/performers')) {
    return PeopleSecondaryMenuItems.PERFORMERS;
  }

  return null;
}

export default getPeopleActiveMenu;
